import React from "react";

// components
import ClientsControl from "./clientsControl/ClientsControl";

const ClientsControls = ({ clients }) => {
  return clients.map((client) => (
    <ClientsControl
      key={client.user_id}
      id={client.user_id}
      name={`${client.first_name} ${client.last_name}`}
      email={client.email}
      phoneNumber={client.phone_number}
      complete={client.total_done}
    />
  ));
};

export default ClientsControls;
